/**
 * Admin origins served behind Identity-Aware Proxy (IAP).
 *
 * The public portal and the admin portal share a parent domain but live on
 * distinct hostnames. These are the hostnames the middleware redirects `/admin`
 * traffic to (see `ADMIN_HOST_REDIRECTS` in `middleware.ts`); code that must know
 * "am I running on the admin origin?" should use {@link isAdminHost} rather than
 * re-checking hostnames inline.
 */
export const ADMIN_HOSTS: readonly string[] = [
  "admin.brainsforrobots.com",
  "staging-admin.brainsforrobots.com",
];

/**
 * True when the given hostname is an IAP-protected admin origin.
 *
 * @param hostname - e.g. `window.location.hostname`.
 */
export function isAdminHost(hostname: string | null | undefined): boolean {
  if (!hostname) {
    return false;
  }
  return ADMIN_HOSTS.includes(hostname.toLowerCase());
}
